module.exports = __webpack_public_path__ + "img/filetypeDoc.7fbec3d2.svg";